package com.esoris.kmpmoout.features.expense.expense_form

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun ExpenseFormScreen(
    viewModel: ExpenseFormViewModel = koinViewModel(),
) {

    val state by viewModel.uiState.collectAsState()
    val onEvent = viewModel::onEvent

    ExpenseFormScreenContent(
        state = state,
        onEvent = onEvent
    )

}